module.exports = __webpack_public_path__ + "static/media/star.99d26ba4.svg";